import { useTasks } from "../Tasks";

const Delete = ({ id, complete }) => {
  const { deleteTask } = useTasks();

  const done = () => {
    deleteTask(id);
  };

  if (complete === true) {
    return (
      <button className="btn delete-btn" onClick={done}>
        Delete
      </button>
    );
  } else {
    return null;
  }
};

export default Delete;
